import React from 'react';
import { Route, Switch } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, MuiThemeProvider } from '@material-ui/core';
import theme from './theme';
import Initial from './components/Initial';
import Room from './components/Room/index';
import CrystalBall from './components/crystal-ball/CrystalBall';
import UserProvider from "./components/UserProvider";

const Router = BrowserRouter as any;
const SwitchComponent = Switch as any;
const RouteComponent = Route as any;

function App() {
  return (
    <Router>
      <CssBaseline />
      <MuiThemeProvider theme={theme}>
        <UserProvider>
          <SwitchComponent>
            <RouteComponent path="/" exact component={Initial} />
            <RouteComponent path="/room/:roomId" component={Room} />
            <RouteComponent path="/crystal-ball" component={CrystalBall} />
          </SwitchComponent>
        </UserProvider>
      </MuiThemeProvider>
    </Router>
  );
}

export default App;